import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

// LIST ALL Status mentorships
export const statusmentorshipList = (params = '') => Http.get(`/mentorship-recruitment-status${serialize(params)}`)
export const statusmentorshipListAll = (params = '') =>
	Http.get(`/mentorship-recruitment-status${serialize(params)}&per_page=all`)
export const statusmentorshipCreate = (params = '') => Http.post('/mentorship-recruitment-status', params)
export const statusmentorshipByID = (params = '') => Http.get(`/mentorship-recruitment-status/${params}`)
export const statusmentorshipUpdate = (params = '') => Http.put(`/mentorship-recruitment-status/${params.id}`, params)
export const statusmentorshipDestroy = (params = '') => Http.delete(`/mentorship-recruitment-status/${params.id}`)
